const initBasicMultiple = () => {
    $(function() {
        $('.js-example-basic-multiple').select2();
    });
}

export { initBasicMultiple };